import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import { useErrorState } from '@/client/components/_hooks/useErrorState'
import { extractFileName } from '@/client/utils/string'

interface Props {
  url: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmImage',
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as {
  url: string
};



const { hasError, onError } = useErrorState()
const fileName = computed(() => extractFileName(props.url))

return { __sfc: true,props, hasError, onError, fileName, Icon }
}

})